module.exports = __webpack_public_path__ + "static/img/tou.d2ca453c.jpg";